module.exports = __webpack_public_path__ + "img/logo.504687b9.png";